import bgFree from '@/assets/images/png/free.png';
import bgGraduation from '@/assets/images/png/graduation.png';
import bgIncludedInPlan from '@/assets/images/png/included.png';
import bgLanguages from '@/assets/images/png/languages.png';
import bgMentorship from '@/assets/images/png/mentoria.png';
import bgPostgraduate from '@/assets/images/png/postgraduate.png';
import bgTechnical from '@/assets/images/png/technical.png';

const courseTypesData = {
  full: {
    description: 'Veja os cursos sem custo para você.',
    image: bgIncludedInPlan,
  },
  non_degree: {
    description: 'Explore novos interesses e desenvolva habilidades únicas.',
    image: bgFree,
  },
  undergraduate: {
    description: 'Dê um passo importante para o seu futuro profissional.',
    image: bgGraduation,
  },
  languages: {
    description: 'Conecte-se com o mundo aprendendo novos idiomas.',
    image: bgLanguages,
  },
  postgraduate: {
    description: 'Aprofunde seu conhecimento e se destaque no mercado.',
    image: bgPostgraduate,
  },
  technical: {
    description: 'Adquira habilidades práticas para uma carreira de sucesso.',
    image: bgTechnical,
  },
  mentorship: {
    description: 'Aprenda com os melhores profissionais do mercado.',
    image: bgMentorship,
  },
};

export const fillCourseTypeData = (type: keyof typeof courseTypesData) => {
  const fallback = courseTypesData[type] || {};
  return {
    description: fallback.description || '',
    image: fallback.image || '',
  };
};
